module HearingLocationPicker {
	let stateSelect: JQuery<HTMLElement>;
	let citySelect: JQuery<HTMLElement>;
	let locationSelect: JQuery<HTMLElement>;

	export function construct() {
		stateSelect = $("#HearingLocationStateSelect");
		citySelect = $("#HearingLocationCitySelect");
		locationSelect = $("#HearingLocationSelect");

		stateSelect.change(stateSelectChanged);
		citySelect.change(citySelectChanged);
		SelectTools.autoSelect(stateSelect);
	}

	const selectedState = () => stateSelect.val() as States;
	const selectedCity = () => citySelect.val() as string;
	const clearOfficeCitySelect = () => citySelect.html("");
	const clearOfficeSelect = () => locationSelect.html("");

	function stateSelectChanged() {
		clearOfficeCitySelect();
		clearOfficeSelect();
		SelectTools.addBlankOption(citySelect);

		const state = selectedState();
		HearingLocationFactory.GetCitiesByState(state,

			(cities: string[]) => {
				$.each(cities, (index, city) => {
					citySelect.append(`<option>${city}</option>`);
				});
				SelectTools.autoSelect(citySelect);
			},

			() => {
				Notifications.Warning(`Failed to retrieve list of cities with Hearing Locations for the state ${state}.`);
			}

		);
	}

	function citySelectChanged() {
		clearOfficeSelect();
		SelectTools.addBlankOption(locationSelect);

		const state = selectedState();
		if (state == States.blank) return;
		const city = selectedCity();
		if (city == null || city == "") return;

		HearingLocationFactory.ByStateCity(state, city,
			(fieldOffices) => {
				$.each(fieldOffices, (index, hearingLocation) => {
					var name = hearingLocation.Address;
					if (hearingLocation.OhoOffice_RowID != null) {
						name += " (OHO)";
					} else if (hearingLocation.FieldOffice_RowID != null) {
						name += " (FO)";
					}
					locationSelect.append(`<option value="${hearingLocation.RowID}">${name}</option>`);
				});
				SelectTools.autoSelect(locationSelect);
			},
			() => {
				Notifications.Warning(`Failed to retrieve list of Hearing Locations for ${city}, ${state}.`);
			}
		);
	}
}